module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAAXNSR0IArs4c6QAAAWRJREFUOE/d1L/LzlEYx/HXx4CSHz2FQTGQxSKZGDwyyUopZZPFrwUjJQODDP4AiwmLJCaDXwOymMiA1UBEKV267r53GR499/1kco3nfM77XD/O5wSqaglO4jC29NoE8RWPcDHJ09ZnAD3ALrzD2wlALVmKbViBA0luNewMLuFakuMTgkayqlqHZ1iDDQ17g0VJNk0DGmuraj9u4lTDCveT7F0gbCU+48q8sKpajM1JXv/tsiGh65PAzuMcliX5PhdwIbDlSb79U1hVbcfRJEf+GEL3faoyR5lV1Stsxeokn4YnMjesqvbgdpJVg3DcswXB2lZXk+T/grX7XyTZPZQ1iztJ2sDtv3ZG22Umyc+qOjv8MBuT/Kiq9XiPC/1o72EnenM0nWmiqi7jNPY1bAee4CNO4GGSL/MBh4yODWeeY3Y8sXb+DbQPp43HOJTkwwg29GYtDqJ7MDMBsSt5ibtJfrX+N1hTEm+ebXX7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/qindex14.png
// module id = dCU6
// module chunks = 20